module.exports = __webpack_public_path__ + "img/p6.dd084b1b.png";